var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#FFD1D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5104 10.4896C26.1632 11.1425 26.1632 12.2009 25.5104 12.8538L20.3653 17.9988L25.5104 23.1462C26.1632 23.7991 26.1632 24.8575 25.5104 25.5104C24.8575 26.1632 23.7991 26.1632 23.1462 25.5104L18.0012 20.363L12.8538 25.5104C12.2009 26.1632 11.1425 26.1632 10.4896 25.5104C9.83679 24.8575 9.83679 23.7991 10.4896 23.1462L15.637 17.9988L10.4896 12.8538C9.83679 12.2009 9.83679 11.1425 10.4896 10.4896C11.1425 9.83679 12.2009 9.83679 12.8538 10.4896L18.0012 15.6347L23.1462 10.4896C23.7991 9.83679 24.8575 9.83679 25.5104 10.4896Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.fe4210906418780c01627c8358878b9e.svg";
export { ForwardRef as ReactComponent };